import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'register', loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
      },
      {
        path: 'profile', loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
      },
      {
        path: 'program/:id',
        loadComponent: () => import('./pages/program/program').then(m => m.ProgramComponent),
        children: [],
      },
      { path: 'home', loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent) },
      {
        path: 'pre-check-in/welcome',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-welcome.component').then((m) => m.PreCheckWelcomeComponent),
      },
      {
        path: 'pre-check-in/schedule',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-schedule.component').then((m) => m.PreCheckScheduleComponent),
      },
      {
        path: 'pre-check-in/meal',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-meal.component').then((m) => m.PreCheckMealComponent),
      },
      {
        path: 'pre-check-in/apply-future',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-apply-future.component').then(
            (m) => m.PreCheckApplyFutureComponent,
          ),
      },
      {
        path: 'pre-check-in/activity',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-activity.component').then((m) => m.PreCheckActivityComponent),
      },
      {
        path: 'pre-check-in/events',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-events.component').then((m) => m.PreCheckEventsComponent),
      },
      {
        path: 'pre-check-in/event-details',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-event-details.component').then(
            (m) => m.PreCheckEventDetailsComponent,
          ),
      },
      {
        path: 'pre-check-in/done',
        loadComponent: () =>
          import('./pages/pre-check-in/pre-check-done.component').then((m) => m.PreCheckDoneComponent),
      },
      { path: 'program-deatils/:id', loadComponent: () => import('./pages/program-details/program-details.component').then(m => m.ProgramDetailsComponent) },
      { path: 'session-expired', loadComponent: () => import('./pages/session-expired/session-expired.component').then(m => m.SessionExpiredComponent) },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
